import { useMemo, type FC } from "react";
import { type ILayoutSubMenu } from "src/contexts/layouts/LayoutContext";
import SubMenu from "./SubMenu";

interface ISubMenusProps {
    subMenus?: ILayoutSubMenu[];
}

interface ISubMenusInternalProps {
    subMenus: ILayoutSubMenu[];
}

const colors = ["white", "black", "black"];

const indicatorColors = [
    "var(--mantine-color-primary-filled)",
    "var(--mantine-color-gray-filled-hover)",
    "var(--mantine-color-gray-filled-hover)"
];

const backgroundColors = ["primary.8", "gray.4", "gray.3"];

const SubMenusInternal: FC<ISubMenusInternalProps> = ({ subMenus }) => {
    const subMenuComponents = useMemo(() => {
        const items: React.ReactNode[] = [];

        let backgroundColorIndex = 0;

        for (const menuItem of subMenus) {
            items.push(
                <SubMenu
                    key={menuItem.code}
                    color={colors[backgroundColorIndex]}
                    backgroundColor={backgroundColors[backgroundColorIndex]}
                    indicatorColor={indicatorColors[backgroundColorIndex]}
                    title={menuItem.title}
                    menuItems={menuItem.items}
                />,
            );

            backgroundColorIndex = (backgroundColorIndex + 1) % backgroundColors.length;
        }

        return items;
    }, [subMenus]);

    return <>{subMenuComponents}</>;
};

const SubMenus: FC<ISubMenusProps> = ({ subMenus: menuItems }) => {
    const hasMenuItems = menuItems && menuItems.length > 0;

    if (!hasMenuItems) {
        return null;
    }

    return <SubMenusInternal subMenus={menuItems} />;
};

export default SubMenus;
